import { render, staticRenderFns } from "./IconCrossSmall.vue?vue&type=template&id=2200ec6c"
import script from "./IconCrossSmall.vue?vue&type=script&lang=js"
export * from "./IconCrossSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports